<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                :label="label"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="rules"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            @input="menu = false"
        ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    data:() => ({
        menu:false,
    }),
    props:{
        value:{
            type:[String,null],
        },
        label:{
            type:String,
            default:'Date'
        },
        rules:{
            type:Array,
            default:() => ([])
        }
    },

    computed:{
        date:{
            get(){
                return this.value
            },
            set(v){
                this.$emit("input", v)
            }
        }
    }
}
</script>

<style>

</style>